import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class ElegibleApproverModel extends Model implements IModel<ElegibleApproverModel> {
  name: string = "";
  registration: string = "";
  email: string = "";

  static create(input: any): ElegibleApproverModel {
    return ObjectMapper.deserialize<ElegibleApproverModel>(
      ElegibleApproverModel,
      input
    );
  }
}

